export var PASSPORT_URL_PREFIXES = {
    BETA_URL_PREFIX: "beta.passport",
    GAMMA_URL_PREFIX: "gamma.passport",
    PROD_URL_PREFIX: "passport.transportation"
};
export var PASSPORT_WS_CORAL_CONFIG = {
    BETA_CONFIG: "Passport.Beta.USAmazon",
    GAMMA_CONFIG: "Passport.Gamma.USAmazon",
    PROD_CONFIG: "Passport.Prod.USAmazon",
    LOCAL_DEV: "Passport.Beta.USAmazon"
};
// External User
export var CARRIER_LOGISTICS_URL_PREFIXES = {
    BETA_URL_PREFIX: "carrierlogistics.integ",
    GAMMA_URL_PREFIX: "carrierlogistics-gamma.aka",
    PROD_URL_PREFIX: "carrierlogistics.amazon"
};
export var CARRIER_LOGISTICS_WS_CONFIG = {
    BETA_CONFIG: "Carrierlogistics.Beta.USAmazon",
    GAMMA_CONFIG: "Carrierlogistics.Gamma.USAmazon",
    PROD_CONFIG: "Carrierlogistics.Prod.USAmazon",
    LOCAL_DEV: "UI.Testing.Local"
};

//# sourceMappingURL=endpointConfig.js.map